if (!customElements.get('product-tabs')) {
  customElements.define(
    'product-tabs',
    class ProductTabs extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

        if (!this.tabs.length || !this.panels.length) return;

        this.addEventListener('click', this.onClick.bind(this), { signal: this.abortController.signal });
        this.addEventListener('keydown', this.onKeydown.bind(this), { signal: this.abortController.signal });
        this.setAttribute('data-enhanced', '');

        const selectedTab = this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || this.tabs[0];
        this.activateTab(selectedTab, false);
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      onClick(event) {
        const tab = event.target.closest('[role="tab"]');
        if (!tab || !this.contains(tab)) return;

        this.activateTab(tab, true);
      }

      onKeydown(event) {
        const tab = event.target.closest('[role="tab"]');
        if (!tab || !this.contains(tab)) return;

        const currentIndex = this.tabs.indexOf(tab);
        let nextIndex;

        switch (event.key) {
          case 'ArrowLeft':
          case 'ArrowUp':
            nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
            break;
          case 'ArrowRight':
          case 'ArrowDown':
            nextIndex = (currentIndex + 1) % this.tabs.length;
            break;
          case 'Home':
            nextIndex = 0;
            break;
          case 'End':
            nextIndex = this.tabs.length - 1;
            break;
          case 'Enter':
          case ' ':
            event.preventDefault();
            this.activateTab(tab, false);
            return;
          default:
            return;
        }

        event.preventDefault();
        this.activateTab(this.tabs[nextIndex], true);
      }

      activateTab(nextTab, moveFocus) {
        const controlledPanelId = nextTab.getAttribute('aria-controls');

        this.tabs.forEach((tab) => {
          const isActive = tab === nextTab;
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.tabIndex = isActive ? 0 : -1;
        });

        this.panels.forEach((panel) => {
          const isActive = panel.id === controlledPanelId;
          panel.classList.toggle('is-active', isActive);
          panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          panel.inert = !isActive;
        });

        if (moveFocus) nextTab.focus({ preventScroll: true });
      }
    }
  );
}
